import type { ViewTransitionName } from "../../config/springs";

/** Names an element for a page morph; the same name on the next page is where it lands. */
export const viewTransitionName = (name: ViewTransitionName) => ({
  className: `vt-${name}`,
});

/** Past this the new page is left to arrive on its own, unmorphed. */
const ARRIVAL_LIMIT_MS = 1000;
/** About a frame; rendering is paused until arrival, so there are no frames to wait on. */
const ARRIVAL_POLL_MS = 16;

const arrival = (name: ViewTransitionName, from: Element | null) =>
  new Promise<void>(resolve => {
    const start = performance.now();
    const check = () => {
      const now = document.querySelector(`.vt-${name}`);
      if (
        (now && now !== from) ||
        performance.now() - start > ARRIVAL_LIMIT_MS
      ) {
        resolve();
      } else {
        setTimeout(check, ARRIVAL_POLL_MS);
      }
    };
    check();
  });

/**
 * Runs a navigation inside a view transition where the browser has one,
 * snapshotting the new page once its `name` element has replaced this one's.
 */
export const withViewTransition = (
  name: ViewTransitionName,
  navigate: () => void,
) => {
  if (typeof document === "undefined" || !document.startViewTransition) {
    navigate();
    return;
  }
  const from = document.querySelector(`.vt-${name}`);
  document.startViewTransition(() => {
    navigate();
    return arrival(name, from);
  });
};
